module.exports = __webpack_public_path__ + "img/invite-program.28685d70.svg";